module.exports = __webpack_public_path__ + "img/SEJ enventos_deatlle registro.d64acd2b.svg";